import React, { useEffect, useState } from 'react';
import { Card, Table, Pagination, message } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import reducer, { initialState } from './reducer';
import saga from './saga';
import _ from 'lodash';
import { toggleDrawer, toggleDeleteModal, listDedicated } from './action';
import clientReducer, { initialState as clientInitialState } from 'pages/Client/reducer';
import clientSaga from 'pages/Client/saga';
import { DedicatedTableConfig } from './DedicatedTableConfig';
import AddDedicatedDrawer from 'components/AddDedicatedDrawer';
import productSaga from 'pages/Product/saga';
import productReducer, { initialState as productInitialState } from 'pages/Product/reducer';
import orderReducer, { initialState as orderInitialState } from 'pages/Orders/reducer';
import orderSaga from 'pages/Orders/saga';
function DedicatedDetails() {
  useInjectReducer({ key: 'dedicated', reducer });
  useInjectSaga({ key: 'dedicated', saga });
  useInjectReducer({ key: 'product', reducer: productReducer });
  useInjectSaga({ key: 'product', saga: productSaga });
  useInjectReducer({ key: 'client', reducer: clientReducer });
  useInjectSaga({ key: 'client', saga: clientSaga });
  useInjectReducer({ key: 'order', reducer: orderReducer });
  useInjectSaga({ key: 'order', saga: orderSaga });
  const [columns, setColumns] = useState([]);
  const [searchText, setSearchText] = useState(null);
  const [searchedColumn, setSearchedColumn] = useState(null);
  const [deleteModalToggle, setDeleteModalToggle] = useState(false);
  const [selectedDedicated, setselectedDedicated] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const dedicatedState = useSelector((state) => state.dedicated || initialState);
  const authState = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  useEffect(() => {
    const columns = DedicatedTableConfig(
      handleSearch,
      handleReset,
      editUserDedicated,
      authState.userResponsibilities,
    );
    setColumns(columns);
    dispatch(listDedicated({ page: 1, limit: 10 }));
  }, []);

  const resetPagination = () => setCurrentPage(1);

  const editUserDedicated = (email) => {
    setselectedDedicated(email);
    dispatch(toggleDrawer());
  };

  const onPageChange = (page, pageSize) => {
    let filter = { page, limit: pageSize };
    setCurrentPage(page);
    if ((searchedColumn, searchText)) {
      filter = { ...filter, [searchedColumn]: searchText };
    }
    dispatch(listDedicated(filter));
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    if (selectedKeys.length <= 0) {
      message.error('Please select to search');
      return;
    }
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
    dispatch(listDedicated({ page: 1, limit: 10, [dataIndex]: selectedKeys[0] }));
    resetPagination();
  };
  // const handleDeleteModalToggle = () => dispatch(toggleDeleteModal());

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText(null);
    setSearchedColumn(null);
    dispatch(listDedicated({ page: 1, limit: 10 }));
    resetPagination();
  };
  return (
    <>
      <Card
        title="Manage Dedicated Server"
        extra={
          <AddDedicatedDrawer
            initialState={initialState}
            clientInitialState={clientInitialState}
            orderInitialState={orderInitialState}
            productInitialState={productInitialState}
            selectedDedicated={selectedDedicated}
            resetPagination={resetPagination}
            editUserDedicated={editUserDedicated}
            roleAddResponsibility={_.includes(authState.userResponsibilities, 'ADD_DEDICATED')}
          />
        }
      >
        <Table
          columns={columns}
          loading={dedicatedState.loading}
          bordered
          pagination={false}
          size={'small'}
          dataSource={dedicatedState.data}
          style={{ height: '70vh', overflow: 'scroll' }}
        />
        <Pagination
          style={{ marginTop: '10px' }}
          total={dedicatedState.totalCount}
          showTotal={(total) => `Total ${total} items`}
          defaultPageSize={10}
          current={currentPage}
          showLessItems={true}
          showSizeChanger={false}
          disabled={dedicatedState.loading}
          onChange={onPageChange}
        />
      </Card>
      {/* <ConfirmModal
        title={'Delete Portfolio Confirmation'}
        text={'Are you sure you want to delete this portfolio ?'}
        toggle={dedicatedState.deleteModal}
        loading={dedicatedState.loading}
        handleDeleteModalToggle={handleDeleteModalToggle}
        onDelete={onDelete}
      /> */}
    </>
  );
}

export default DedicatedDetails;
